export const development = {
  Region: 'ap-northeast-1',
  UserPoolId: 'ap-northeast-1_im7u0sabG',
  ClientId: 'hk3ckrh7924imfop2h45d82it',
  IdentityPoolId: 'ap-northeast-1:670475951502:userpool/ap-northeast-1_im7u0sabG',
};


export const production = {
  Region: 'ap-northeast-1',
  UserPoolId: 'ap-northeast-1_Jg2AyJ32X',
  ClientId: '7hniks33bcvqlpp8efd2kjecnb',
  IdentityPoolId: 'ap-northeast-1:538632460747:userpool/ap-northeast-1_Jg2AyJ32X',
};

